import { useState, useRef, useEffect } from 'react';
import { Link, useLocation, useParams } from "react-router-dom";

import { Worker, Viewer, TextDirection, LocalizationContext } from '@react-pdf-viewer/core';
import { pageNavigationPlugin } from '@react-pdf-viewer/page-navigation';
import { searchPlugin } from '@react-pdf-viewer/search';
import { zoomPlugin } from '@react-pdf-viewer/zoom';
import { highlightPlugin } from "@react-pdf-viewer/highlight";

import { MdBookmarkAdd, MdDraw, MdNotes, MdOutlineBookmarkBorder, MdOutlineSearch, MdOutlineSpeakerNotes, MdOutlineZoomInMap, MdSearch, MdZoomIn, MdZoomOut } from 'react-icons/md';
import { HiChatBubbleBottomCenterText, HiChatBubbleOvalLeftEllipsis } from "react-icons/hi2";


import Fetch, { GET, Loader } from '../../inc/Fetch';
import { Config } from '../../inc/Config';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/search/lib/styles/index.css';
import "@react-pdf-viewer/page-navigation/lib/styles/index.css";
import '@react-pdf-viewer/highlight/lib/styles/index.css';

import './css/newBook.css';

import Paging from './paging';
import { useContext } from 'react';
import { AppContext } from '../../Context';
import { Img } from '../../components/Elements';
import { MainUserMenu } from '../../components/Menu';
import Draw from './Draw';
import Login from '../popups/Login';
import SearchUI from './Search';
import { LuClipboardList, LuSearch } from 'react-icons/lu';
import { Helmet } from 'react-helmet';
import { GoTasklist } from 'react-icons/go';
import { FaThList } from 'react-icons/fa';
import { RiListCheck2 } from 'react-icons/ri';
import { IoBookmarkOutline, IoChatbubbles, IoSearchOutline } from 'react-icons/io5';
import AddNotes from '../popups/addNotes';

export default function NewBook() {

    const drawingsRef = useRef({});
    const viewerRef = useRef();
    const params = useParams();
    const GAP = 15;

    const [loading, setLoading] = useState(false);
    const [pageLoad, setpageLoad] = useState(true);
    const [data, setdata] = useState({});
    const [quiz, setquiz] = useState([]);
    const [page, setpage] = useState(1);
    const [zoom, setzoom] = useState(1.3);
    const [showDraw, setshowDraw] = useState(false);
    const [pdfIndex, setPdfIndex] = useState([]);
    const [addNotesAllow, setAddNotesAllow] = useState(false);
    const [addNotesForm, setAddNotesForm] = useState(false);
    const [notesList, setNotesList] = useState([]);
    const [bookmarkPage, setBookmarkPage] = useState(false);
    const [openQuiz, setOpenQuiz] = useState(false);
    
    const [searchActive, setsearchActive] = useState(false);

    const {success, userinfo, showQuiz, languageText, loginForm} = useContext(AppContext);
    const [open, setopen] = success;
    const [showQuizD, setshowQuizD] = showQuiz;
    const [text, settext] = languageText;
    const [user, setuser] = userinfo;
    const [openLogin, setopenLogin] = loginForm;
    

    const pageNavigationPluginInstance = pageNavigationPlugin();
    const { jumpToPage } = pageNavigationPluginInstance;
    const zoomPluginInstance = zoomPlugin();

    const searchPluginInstance = searchPlugin();
    const { Search } = searchPluginInstance;

    const openLinksInNewTabPlugin = {
        onAnnotationLayerRender: (e) => {
            // Find all <a> tags inside the annotation layer
            e.container.querySelectorAll("a").forEach((link) => {
                // Force external URLs to open in a new tab
                link.setAttribute("target", "_blank");
                link.setAttribute("rel", "noopener noreferrer");
            });
        },
    };

    const arabicLocale = {
        // You can customize these strings to your liking
        'core': {
            'search': 'بحث',
            'zoom': 'تكبير/تصغير',
            'previousPage': 'الصفحة السابقة',
            'nextPage': 'الصفحة التالية',
        },
        // Add other plugin translations here if needed
    };

    const highlightPluginInstance = highlightPlugin({
        onTextLayerRender: ({ pageIndex, textLayerDiv }) => {
            const page = data[pageIndex];
            if (!page || !keyword) return;

            textLayerDiv.querySelectorAll('span').forEach((span) => {
                if (span.textContent.includes(keyword)) {
                    const rect = span.getBoundingClientRect();
                    highlightPluginInstance.addHighlight({
                        pageIndex,
                        rects: [
                            { x1: rect.left, y1: rect.top, x2: rect.right, y2: rect.bottom }
                        ],
                        color: 'yellow',
                    });
                }
            });
        },
        renderHighlightTarget: (props) => (
            <div
                style={{
                    background: '#eee',
                    display: 'flex',
                    position: 'absolute',
                    left: `${props.selectionRegion.left}%`,
                    top: `${props.selectionRegion.top + props.selectionRegion.height}%`,
                    transform: 'translate(0, 8px)',
                    zIndex: 1,
                }}
            >
                <button
                    onClick={() => {
                        // Here you can add the logic to save the highlight 
                        // to your database or local state
                        props.toggle();
                    }}
                    style={{
                        background: '#357edd',
                        color: '#fff',
                        border: 'none',
                        padding: '8px',
                        cursor: 'pointer',
                    }}
                >
                    تحديد النص
                </button>
            </div>
        ),
    });

    const handleDocumentLoad = async (e) => {
        const pdf = e.doc;
        const pages = [];

        for (let i = 1; i <= pdf.numPages; i++) {
            const page = await pdf.getPage(i);
            const textContent = await page.getTextContent();

            const text = textContent.items
                .map((item) => item.str)
                .join("");
                
            pages.push({
                pageIndex: i - 1,
                text,
            });
        }

        setPdfIndex(pages);
    };

    function pagingTo(page) { 
        jumpToPage(page);
    }

    function addBookMark(data) {
        setLoading(true);

        Fetch("books/addBookMark", (d) => {
            
            setBookmarkPage(data?.page);
            setLoading(false);
            
        }, { book: data?.book, page: data?.page});

        return false;
    }
    
    async function loadData() { 
        
        
        setpageLoad(true);

        let res = await GET(`books/viewOne/${params?.id}`);

        if (res?.book?.book?.length) {
            setNotesList(res?.notes);
            setBookmarkPage(res?.bookmark?.page);
            setdata(res?.book);
            setquiz(res?.quiz);
        } else {
            setdata({});
            setquiz([]);
        }

        setpageLoad(false);
    }
    useEffect(() => {
        loadData();
    }, []);
    
    useEffect(() => {
        zoomPluginInstance.zoomTo(zoom);
    }, [zoom]);

    useEffect(() => {
        if (!showDraw) {
            let body = viewerRef?.current?.querySelector('.pdfBookBox .rpv-core__inner-pages');
            body?.classList.remove("noScroll");
        }
    }, [showDraw]);

    // Add notes on click
    useEffect(() => {

        function handleClick(e) {
            if (!addNotesAllow) return;
            let target = e.target?.closest('.rpv-core__page-layer');
            let pageIndex = target?.getAttribute('data-virtual-index');
            
            if (pageIndex) {
                const rect = target?.getBoundingClientRect();

                pageIndex = parseInt(pageIndex);
                let x = e.clientX - rect.left;
                let y = e.clientY - rect.top;

                const xPercent = (x / rect.width) * 100;
                const yPercent = (y / rect.height) * 100;
                
                setAddNotesForm({
                    page: pageIndex,
                    x: xPercent,
                    y: yPercent,
                    book: params?.id
                });
                // console.log(xPercent, yPercent, pageIndex);

            }
        }

        const timer = setTimeout(() => {
            if (viewerRef.current) {
                viewerRef.current.addEventListener('click', handleClick);
            }
        }, 600);

        return () => {
            clearTimeout(timer);
            if (viewerRef.current) {
                viewerRef.current.removeEventListener('click', handleClick);
            }
        };
    }, [addNotesAllow]);

    if (pageLoad) return <Loader />

    if (!data?._id) return;
    
    const pageLayout = {
        buildPageStyles: () => ({
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }),

        transformSize: ({ size }) => ({
            width: size.width, 
            height: size.height + GAP,
        }),
    };  
    
    function openFullscreen() {

		const fullScreenCk = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;

		var elem = document.documentElement;

		if (!fullScreenCk) {
			if (elem.requestFullscreen) {
				elem.requestFullscreen();
			} else if (elem.webkitRequestFullscreen) {
				elem.webkitRequestFullscreen();
			} else if (elem.msRequestFullscreen) {
				elem.msRequestFullscreen();
			}
		} else {
			if (document.exitFullscreen) {
				document.exitFullscreen();
			} else if (document.webkitExitFullscreen) {
				document.webkitExitFullscreen();
			} else if (document.msExitFullscreen) {
				document.msExitFullscreen();
			}
		}
	}


    return (
        <LocalizationContext.Provider value={{ l10n: arabicLocale }}>

            {loading && <Loader />}

        {addNotesForm && <AddNotes setAddNotesAllow={setAddNotesAllow} setNotesList={setNotesList} setopen={setAddNotesForm} open={addNotesForm} />}

        <Helmet>
            <title>{data?.name?.name}</title>
            <meta name="description" content={data?.description} />
        </Helmet>

        {openLogin && <Login setopen={setopenLogin} open={openLogin} />}
        <nav className='bookHeaderBox'>
            <ul className='right'>
                {user?.userinfo?._id && 
                    <>
                        <a href='#' title='عرض الدروس' onClick={() => setOpenQuiz(d => !d)}><RiListCheck2 /></a>
                        <a href='#' className={searchActive ? 'active' : ''} title='بحث' onClick={() => setsearchActive(!searchActive)}><MdSearch /></a>
                        <a href='#' className={addNotesAllow ? 'active' : ''} title='ملاحظات' onClick={() => setAddNotesAllow(d => !d)}><MdNotes /></a>
                        <a href='#' title='مفضلة' onClick={() => pagingTo(bookmarkPage)}>
                            {bookmarkPage && <span>{bookmarkPage + 1}</span>}
                            <MdOutlineBookmarkBorder />

                        </a>
                    </>
                }
                <a href='#' title='تكبير' onClick={() => setzoom(zoom + 0.2)}><MdZoomIn /></a>
                <a href='#' title='تصغير' onClick={() => setzoom(zoom - 0.2)}><MdZoomOut /></a>
                <a href='#' title='ملء الشاشة' onClick={openFullscreen}><MdOutlineZoomInMap /></a>
            </ul>

            <h1>{data?.name?.name}</h1>

            <div className='left'>
                {!user?.userinfo?._id ? 
                    <b><a href='#' style={{color:"#fff"}} onClick={() => setopenLogin(true)}>مرحبا, انت زائر</a></b>
                :
                    <div className='outterUserBox'>
                        <a href='#' className='mainLink'><Img src={`img/40x40${user?.userinfo?.img}`} />{user?.userinfo?.name}</a>
                        <MainUserMenu />
                    </div>
                }
            </div>
        </nav>

        {openQuiz && <div className='qListBox'>
            <h3>الدروس المحوسبة</h3>
            {quiz?.map((v, k) => {
                
                return (
                    <a  onClick={() => jumpToPage(v?.page_number - 1)} key={k}className='qListItem'>
                        <Img src={`${Config?.imgUrl}${v?.img}`} />
                        <div className='qListInfo'>
                            <h4>{v?.name}</h4>
                            <p>صفحة: {v?.page_number}</p>
                        </div>
                    </a>
                );
            })}
        </div>}
        
        <div ref={viewerRef} className={`bookViewBox ${addNotesAllow ? 'addNotesAllow' : ''}`}>
            
            <Paging page={page} plugin={pageNavigationPluginInstance} />

            {searchActive && <SearchUI
                data={pdfIndex}
                plugin={pageNavigationPluginInstance}
                searchPluginInstance={searchPluginInstance}
            />}
            
            <Worker 
                workerUrl="/pdf.worker.min2.js"
            >
                <Viewer 
                    
                    plugins={[ pageNavigationPluginInstance, zoomPluginInstance, openLinksInNewTabPlugin,  searchPluginInstance, highlightPluginInstance ]}
                    defaultScale={zoom}
                    fileUrl={`${Config?.imgUrl}${data?.book[0]}`} 
                    pageLayout={pageLayout}
                    onPageChange={(e) => {
                        setpage(e?.currentPage + 1);
                    }}

                    renderPage={(props) => {

                        let catID = false;
                        let classesID = false;

                        let quizData = quiz?.find(q => q?.page_number == props?.pageIndex + 1);
                        if (quizData?._id) {
                            catID = quizData?.cats[0]?._id;
                            classesID = quizData?.classes[0];
                        }

                        if (user?.userinfo?._id) {
                            return (
                                <> 
                                    <div className='rightRichOptions'>
                                        {props?.pageIndex ? <a href='#' onClick={() => addBookMark({ book: params?.id, page: props?.pageIndex })} title='حفظ الصفحة' className='drawBtn'><MdBookmarkAdd style={{borderColor:"#555", background:"#555"}} /></a> : null}
                                        {props?.pageIndex ? <a href='#' onClick={() => setshowDraw(props?.pageIndex)} title='رسم' className='drawBtn'><MdDraw /></a>: null}
                                        {quizData?._id ? <a target='_blank' href={`/cat/${classesID}/${catID}/${quizData?._id}`} title='الدرس المحوسب' className='taskBtn'><GoTasklist /></a>: null}
                                    </div>

                                    {notesList?.map((v, k) => {
                                        if (v?.page == props?.pageIndex) {

                                            return(
                                                <a onClick={() => setAddNotesForm(v)} key={k} style={{top:`${v?.y}%`, left: `${v?.x}%`}} title={v?.note} className='notesListBox'><HiChatBubbleBottomCenterText /></a>
                                            )
                                        }
                                    })}
                                    


                                    {showDraw == props?.pageIndex && <Draw drawingsRef={drawingsRef} setshowDraw={setshowDraw} show={showDraw} />}
                                    {props.canvasLayer.children}
                                    {props.annotationLayer.children}
                                    {props.textLayer.children}
                                </>
                            );
                        } else {

                            if (props?.pageIndex <= 10) {
                                return (
                                    <>
                                        {props.canvasLayer.children}
                                        {props.annotationLayer.children}
                                        {props.textLayer.children}
                                    </>
                                );
                            } else {
                                return (
                                    <>
                                        <div className='nopagesText'>قم بتسجيل الدخول لمتابعة القراءة</div>
                                        {props.annotationLayer.children}
                                    </>
                                );
                            }
                        }
                        
                    }}
                    onDocumentLoad={handleDocumentLoad}
                />
            </Worker>
        </div>
        </LocalizationContext.Provider>

    )
}
